import React from 'react';
import { CheckIcon, CreditCardIcon, EyeIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { HERO_IMAGE, offerIncludes } from '../data/content';
import { CtaButton } from './CtaButton';
import { Accent, SectionHeading } from './SectionHeading';
const trustBadges = [{
  icon: ZapIcon,
  label: 'Acceso inmediato'
}, {
  icon: CreditCardIcon,
  label: 'Pago único'
}, {
  icon: ShieldCheckIcon,
  label: 'Garantía 7 días'
}, {
  icon: LockIcon,
  label: 'Pago seguro'
}];
export function OfferSection() {
  return <section id="oferta" className="w-full scroll-mt-4 bg-cream-200 px-6 py-14 sm:py-16" aria-labelledby="oferta-titulo" data-id="element-115" data-mp="mdif1ug4z94g">
      <div className="mx-auto max-w-3xl" data-id="element-116" data-mp="wczkcarh7kzw">
        <SectionHeading id="oferta-titulo" badge="Tu acceso completo" title={<>
              Kit Instrumentación Industrial <Accent data-id="element-118" data-mp="2y4cqt493e0y2">Completo</Accent>
            </>} data-id="element-117" data-mp="wbya28iab2j8" />

        <div className="relative mx-auto -mb-2 mt-4 w-full max-w-md" data-id="element-119" data-mp="2y6gq18w1qbs0">
          <img src={HERO_IMAGE} alt="Contenido completo del Kit Instrumentación Industrial: 6 volúmenes y 5 bonos" className="w-full" data-id="element-120" data-mp="12oa9kycxqdkt" />
          <span className="absolute -right-1 top-2 flex h-24 w-24 flex-col items-center justify-center text-center font-display font-bold leading-none text-white sm:h-28 sm:w-28" style={{
          backgroundColor: '#C9542B',
          clipPath: 'polygon(50% 0%, 61% 12%, 78% 6%, 82% 24%, 98% 30%, 90% 46%, 100% 60%, 84% 68%, 86% 86%, 68% 84%, 58% 98%, 44% 88%, 28% 96%, 24% 78%, 6% 74%, 12% 58%, 0% 44%, 14% 34%, 8% 16%, 26% 18%, 34% 2%)'
        }} data-id="element-121" data-mp="swxii8yynrfu">
            <span className="text-2xl sm:text-3xl" data-id="element-122" data-mp="17ltn1w1t6mbp">80%</span>
            <span className="mt-1 text-[0.6rem] uppercase tracking-widest" data-id="element-123" data-mp="169ix1cxqu4a">OFF</span>
          </span>
        </div>

        <div className="mt-6 rounded-3xl bg-cream-50 p-7 text-center shadow-card sm:p-9" data-id="element-124" data-mp="3sckmp59by8zb">
          <p className="text-sm text-forest-700/60" data-id="element-125" data-mp="3tthouscyp06s">
            Precio normal: <span className="line-through" data-id="element-126" data-mp="3ts6lgtnfhug7">$97 USD</span>
          </p>
          <p className="mt-2 text-xs font-bold uppercase tracking-[0.16em] text-ember-500" data-id="element-127" data-mp="2n6hkehcz370">
            Precio de lanzamiento
          </p>
          <p className="mt-3 font-display text-6xl font-bold text-forest-800" data-id="element-128" data-mp="3ouwl4iyi3ydl">
            $19 <span className="text-2xl font-semibold text-forest-700/55" data-id="element-129" data-mp="3owr8s515q4ld">USD</span>
          </p>

          <p className="mt-4 flex items-center justify-center gap-2 text-sm text-forest-700/60" data-id="element-130" data-mp="3b1f5h98xr5su">
            <EyeIcon className="h-4 w-4" aria-hidden="true" data-id="element-131" data-mp="3fwb7n27vz9jo" />
            14 docentes viendo esto ahora
          </p>

          <CtaButton className="mt-7" source="oferta" data-id="element-132" data-mp="364ey8v0cnx05" />

          <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs font-medium text-forest-700/70" data-id="element-133" data-mp="364ydg3ym87ah">
            {trustBadges.map(({
            icon: Icon,
            label
          }) => <li key={label} className="flex items-center gap-1.5" data-id="element-134" data-mp="2x2fg1zdlmmvm">
                <Icon className="h-3.5 w-3.5 text-forest-400" aria-hidden="true" data-id="element-135" data-mp="2dhf6pmt1xz70" />
                {label}
              </li>)}
          </ul>

          <ul className="mt-6 divide-y divide-cream-200 border-t border-cream-200 text-left" data-id="element-136" data-mp="28kyjqvxl9qvi">
            {offerIncludes.map(({
            label,
            value
          }) => <li key={label} className="flex items-center gap-2.5 py-1.5" data-id="element-137" data-mp="2igs2ix1wiglq">
                <CheckIcon className="h-3 w-3 shrink-0 text-ember-500" strokeWidth={3} aria-hidden="true" data-id="element-138" data-mp="2wgjd0nt7leuz" />
                <span className="min-w-0 flex-1 truncate text-xs font-medium text-forest-800" data-id="element-139" data-mp="2ri82sbz052c8">{label}</span>
                {value ? <span className="shrink-0 text-[0.65rem] font-semibold text-forest-700/50" data-id="element-140" data-mp="3662x1wsnrerf">{value}</span> : null}
              </li>)}
          </ul>
        </div>

        <div className="mx-auto mt-6 max-w-2xl rounded-2xl bg-cream-100/80 p-6 text-center" data-id="element-141" data-mp="3f82egq7l4kuw">
          <h3 className="font-display text-xl font-semibold text-forest-800" data-id="element-142" data-mp="3a98zsugkant5">Por qué hoy es el momento</h3>
          <p className="mt-3 text-sm leading-relaxed text-forest-700/75" data-id="element-143" data-mp="18i8vro051k56">
            Hoy recibís los 6 volúmenes técnicos (360 páginas) + los 5 bonos de implementación (150 páginas) a
            precio de lanzamiento. Después de esta ventana, el precio sube a $97 USD.
          </p>
          <p className="mt-3 text-sm font-semibold text-ember-600" data-id="element-144" data-mp="1m9dm1zhm902u">
            71% de los cupos ya se tomaron. Solo quedan 29 accesos al precio de lanzamiento.
          </p>
        </div>
      </div>
    </section>;
}